const MenuIcon = ({ className, isSelected = false }) => {
  const fillColor = isSelected ? '#FFFFFF' : '#000000'

  return (
    <div
      className={`${className} flex items-center justify-center w-[24px] h-[24px]`}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 12H21M3 6H21M3 18H21"
          stroke={fillColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default MenuIcon
